export const API_URL = "https://jansevak.drvedhealthcare.com";

const AppApiResources = {
  login: "/api/user/login",
  janaList: "/api/janalist/get"
};

export default AppApiResources;
